import React from "react";

//Components
import Header from "../components/Navigation/Header";
import Paragraph, { MultiParagraph } from "../components/Paragraph";
import Title from "../components/Title";
import MultiCard from "../components/Cards/MultiCard";
import List from "../components/List/List";
import Footer from "../components/Navigation/Footer";

//Assets
import { Intro, About, Details, Terms } from "../assets/Content";

export default function Home() {
  return (
    <div>
      <Header />
      <div className="Main" style={{ backgroundColor: "#F3F4F7" }}>
        {Intro.map((data, index) => {
          return (
            <div
              id={data.id}
              style={{ paddingTop: 80, paddingBottom: 80 }}
              key={data.title + index}
            >
              <Paragraph data={data} />
            </div>
          );
        })}

        <div style={{ paddingTop: 80, paddingBottom: 80 }} id="About">
          <Title
            title="About Us"
            overlay="IG Agent"
            para="IG AGENT is an Call Dialer but It has the capability of storing feedback, generating a list based on those feedbacks for following up later. It also possesses an in-built CRM, which does everything a CRM department does from a simple smartphone, saving on manpower and infrastructure required for the department. With the feature of bulk messaging, it takes care of your messaging needs too.
IG AGENT’s prowess does not end here. It can now do things that will make life not only easier for you but give you the additional edge over your competitors.
With the Nearby feature, your field force can now locate nearby customers.
IG AGENT provides the option of creating Custom fields, which lets you store additional information like price offered to a certain client. So the next time you call the client, you will know how to negotiate and close the deal with the help of notes created in the past. With IG AGENT you will never be lacking in information.
And that is not all, You can easily automate the workflow, signup from your landing page can go directly inside IG AGENT and your agents can start engaging customers instantly.
Investment in property is one of the most important investments in an individual's life, it is not something simple. So make your clients experience the best with the help of IG AGENT, when they are dealing with you, and not only succeed in closing the deal but also create a relationship with him, that would gain you valuable references."
          />
          <div
            style={{
              display: "flex",
              flexFlow: "row wrap",
              justifyContent: "center",
            }}
          >
            {About.map((data, index) => {
              return (
                <MultiParagraph
                  id={data.id}
                  data={data}
                  key={data.title + index}
                />
              );
            })}
          </div>
        </div>

        <div id="Services" style={{ paddingTop: 80, paddingBottom: 80 }}>
          <div
            style={{
              background: "#fff",
              boxShadow: "2px 2px 15px #ccc",
              paddingTop: 40,
              paddingBottom: 40,
            }}
          >
            <Title
              title="Our Services"
              overlay="What we provide"
              para="Being a real estate agent in these trying times is anything easy. And with the world gathering pace and clients becoming busier than ever, it really is difficult to convince them to invest in your property.
Therefore, This is the proper time to make a little change in your approach. Since the times are tough, connecting to more clients than before is of paramount importance.
Now, the problem that arises with having clients more than a controllable number is keeping track of their feedback."
            />
          </div>
          {Details.map((data, index) => {
            return data.type === "card" ? (
              <div
                key={data.title + index}
                style={{
                  paddingTop: 40,
                  paddingBottom: 40,
                }}
              >
                <Title
                  title={data.title}
                  overlay={data.overlay}
                  para={data.para}
                />
                <div
                  style={{
                    display: "flex",
                    flexFlow: "row wrap",
                    justifyContent: "center",
                  }}
                >
                  {data.card.map((card, index) => {
                    return <MultiCard data={card} key={data.title + index} />;
                  })}
                </div>
              </div>
            ) : (
              <Paragraph data={data} key={data.title + index + index} />
            );
          })}
        </div>

        <div style={{ background: "#fff", boxShadow: "2px 2px 15px #ccc" }}>
          {Terms.map((data, index) => {
            return (
              <div
                id={data.id}
                style={{ paddingTop: 80, paddingBottom: 80 }}
                key={data.title + index}
              >
                <Title
                  overlay={data.overlay}
                  title={data.title}
                  para={data.para}
                />
                {data.points ? (
                  <List listItem={data.points} key={data.title + index} />
                ) : null}
              </div>
            );
          })}
        </div>
      </div>

      <Footer />
    </div>
  );
}
